// components/wrapper-client-body.tsx

"use client";

import { setThemeCookie } from "@/data/cookieClient";
import { ThemeType } from "@/lib/types";
import useAppSettings from "@/store/appSettings";
import type { Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import { useEffect, type ReactNode } from "react";
import SessionExpiredModal from "./auth/session-expired-modal";
import { SessionSync } from "./session-sync";

interface ClientSessionAndBodyWrapperProps {
  session: Session | null; // Explicitly typed as nullable Session
  children: ReactNode;
  theme: ThemeType;
}

const ClientSessionAndBodyWrapper: React.FC<
  ClientSessionAndBodyWrapperProps
> = ({ session, children, theme }) => {
  const { theme: zustandStore, setTheme } = useAppSettings();

  useEffect(() => {
    if (theme) {
      setThemeCookie(theme);
      setTheme(theme);
    }
  }, [theme, setTheme]);

  return (
    <SessionProvider session={session}>
      <SessionSync />
      <SessionExpiredModal />
      {children}
    </SessionProvider>
  );
};

export default ClientSessionAndBodyWrapper;
